<template>
  <div class="kt-grid kt-grid--ver kt-grid--root kt-page">
    <div id="kt_login" class="kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v1">
      <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--ver-desktop kt-grid--hor-tablet-and-mobile">
        <div class="kt-grid__item kt-grid__item--fluid kt-grid__item--order-tablet-and-mobile-1 kt-login__wrapper">
          <!--begin::Content-->
          <!-- <div class="kt-grid__item kt-grid__item--fluid kt-grid__item--order-tablet-and-mobile-1 kt-login__wrapper"> -->
          <!--begin::Head-->

          <!--end::Head-->

          <!--begin::Body-->
          <div class="kt-login__body">
            <!--begin::Signin-->
            <div class="kt-login__form">
              <div class="d-flex flex-column-fluid">
                <!--begin::Container-->
                <div v-if="!isLoading" class=" container ">
                  <div class="card card-custom">
                    <div class="card-body p-20 kt-margin-t-20">
                      <!--begin::Wizard-->
                      <div id="kt_wizard_v1" class="wizard wizard-1" data-wizard-state="first" data-wizard-clickable="false">
                        <!--begin::Wizard Body-->
                        <div v-if="!isWaitResponse" class="row justify-content-center my-10 px-8 my-lg-15 px-lg-10 kt-align-center">
                          <div v-if="checkVerifyResult">
                            <svg
                              id="Capa_1"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                              version="1.1"
                              x="0px"
                              y="0px"
                              viewBox="0 0 512 512"
                              style="enable-background:new 0 0 512 512;"
                              xml:space="preserve"
                              width="80px"
                              height="80px"
                              class=""
                            >
                              <g>
                                <g>
                                  <g>
                                    <path d="M437.019,74.98C388.667,26.629,324.38,0,256,0C187.619,0,123.331,26.629,74.98,74.98C26.628,123.332,0,187.62,0,256    s26.628,132.667,74.98,181.019C123.332,485.371,187.619,512,256,512c68.38,0,132.667-26.629,181.019-74.981    C485.371,388.667,512,324.38,512,256S485.371,123.333,437.019,74.98z M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30    s226,101.383,226,226S380.617,482,256,482z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#00AF80" />
                                  </g>
                                </g><g>
                                  <g>
                                    <path d="M378.305,173.859c-5.857-5.856-15.355-5.856-21.212,0.001L224.634,306.319l-69.727-69.727    c-5.857-5.857-15.355-5.857-21.213,0c-5.858,5.857-5.858,15.355,0,21.213l80.333,80.333c2.929,2.929,6.768,4.393,10.606,4.393    c3.838,0,7.678-1.465,10.606-4.393l143.066-143.066C384.163,189.215,384.163,179.717,378.305,173.859z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#00AF80" />
                                  </g>
                                </g>
                              </g>
                            </svg>
                            <div class="col-xl-12">
                              <!--begin::Wizard Form-->
                              <div class="kt-margin-30">
                                <h1>Welcome to ELI</h1>
                                <h4>Your email has been verified</h4>
                              </div>
                            </div>
                            <div class="kt-margin-30 kt-align-center">
                              <router-link :to="`/login`">
                                <button
                                  type="button"
                                  class="btn btn-brand btn-sm kt-block-center sign-up-msg"
                                  @click="trackCustomEvent({ action: 'clicked', target: 'login_verify', linkTo: 'login' })"
                                >
                                  <span class="kt-font-bold">Go to login page</span>
                                </button>
                              </router-link>
                            </div>
                          </div>

                          <div v-else>
                            <svg
                              id="Capa_1"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                              version="1.1"
                              x="0px"
                              y="0px"
                              viewBox="0 0 475.2 475.2"
                              style="enable-background:new 0 0 475.2 475.2;"
                              xml:space="preserve"
                              width="80px"
                              height="80px"
                              class=""
                            ><g><g>
                              <g>
                                <path d="M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6    s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7    s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7    C468.6,170.8,468.6,304.4,386.5,386.5z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#C12020" />
                                <path d="M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1    l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4    c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#C12020" />
                              </g>
                            </g></g> </svg>
                            <div class="col-xl-12r">
                              <!--begin::Wizard Form-->
                              <div class="kt-margin-30">
                                <!-- <h1>Welcome to ELI</h1> -->
                                <h4>Your email can't be verified</h4>
                              </div>
                            </div>
                            <div class="kt-margin-30 kt-align-center">
                              <router-link :to="`/login`">
                                <button
                                  type="button"
                                  class="btn btn-brand btn-sm kt-block-center sign-up-msg"
                                  @click="trackCustomEvent({ action: 'clicked', target: 'login_verify', linkTo: 'login' })"
                                >
                                  <span class="kt-font-bold">Go to login page</span>
                                </button>
                              </router-link>
                            </div>
                          </div>
                        </div>
                        <div v-if="isVerified" class="kt-align-center">
                          <div class="col-xl-12">
                            <!--begin::Wizard Form-->
                            <svg xmlns="http://www.w3.org/2000/svg" height="80px" viewBox="0 -46 417.81333 417" width="80px" class=""><g><path d="m159.988281 318.582031c-3.988281 4.011719-9.429687 6.25-15.082031 6.25s-11.09375-2.238281-15.082031-6.25l-120.449219-120.46875c-12.5-12.5-12.5-32.769531 0-45.246093l15.082031-15.085938c12.503907-12.5 32.75-12.5 45.25 0l75.199219 75.203125 203.199219-203.203125c12.503906-12.5 32.769531-12.5 45.25 0l15.082031 15.085938c12.5 12.5 12.5 32.765624 0 45.246093zm0 0" fill="#00AF80" data-original="#2196F3" class="active-path" data-old_color="#2196f3" /></g> </svg>
                            <div class="kt-margin-30">
                              <h3>Your email has been verified</h3>
                              <span>You can now sign in with your account</span>
                            </div>
                          </div>
                          <div class="kt-margin-30 kt-align-center">
                            <router-link :to="`/login`">
                              <button
                                type="button"
                                class="btn btn-brand btn-sm kt-block-center sign-up-msg"
                                @click="trackCustomEvent({ action: 'clicked', target: 'login_verify', linkTo: 'login' })"
                              >
                                <span class="kt-font-bold">Go to login page</span>
                              </button>
                            </router-link>
                          </div>
                        </div>
                        <!--end::Wizard Body-->
                      </div>
                    </div>
                    <!--end::Wizard-->
                  </div>
                </div>
                <!--end::Container-->
              </div>
            </div>

            <!--end::Signin-->
          </div>

          <!--end::Body-->
          <!-- </div> -->

        <!--end::Content-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      result: '',
      isWaitResponse: false,
      isVerified: false,
      isLoading: false
    }
  },
  computed: {
    checkVerifyResult () {
      return this.result === 'authorized'
    }
  },
  mounted () {
    this.verifyEmail()
  },
  methods: {
    ...mapActions({
      verifyEmailRequest: 'user/verifyEmail',
      trackCustomEvent: 'user/trackCustomEvent'
    }),
    async verifyEmail () {
      this.isWaitResponse = true
      this.isLoading = true
      const verifyResult = await this.verifyEmailRequest(this.$route.query)
      this.result = verifyResult ? verifyResult.message : undefined
      if (this.result) {
        this.isWaitResponse = false
      } else {
        this.isVerified = true
      }
      this.isLoading = false
    }
  }
}
</script>

<style scoped>
.kt-login.kt-login--v1 .kt-login__wrapper {
  padding-top: 13rem;
}
</style>
